
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.outline-video{
  aspect-ratio:16/9;
  position:relative;
}

.outline-video.modal{
  width:100%;
  height:100%;
}

.outline-video.player{
  width:100%;
  height:100%;
  max-height:700px;
}

.outline-video.inline{
  position:relative;
  aspect-ratio:unset;
  width:100%;
  height:100%;
}

.outline-video--button{
  position:absolute;
  border-radius:50%;
  padding:1.5rem;
  background-color:var(--brand-bright-blue-900);
  border:none;
  transition-duration:200ms;
  transition-property:outline-width, padding;
  outline:solid 0px var(--brand-white);
  z-index:1;
}

.outline-video--button svg{
    z-index:1;
    position:absolute;
    top:29%;
    left:29%;
    height:21px;
    width:21px;
  }

.outline-video--button:after{
    content:'';
    transition-duration:200ms;
    outline:1px solid transparent;
    transition-property:outline-width;
  }

.outline-video--button:before{
    content:'';
    transition-duration:200ms;
    outline:1px solid transparent;
    transition-property:outline-width;
  }

.outline-video--button:hover:before{
      position:absolute;
      top:0;
      left:0;
      height:100%;
      width:100%;
      border-radius:50%;
      outline:3px solid var(--brand-bright-blue-900);
    }

.outline-video--button:focus{
    border:var(--brand-blue-300) solid 1px;
    outline-width:5px;
  }

.outline-video--button:focus:after{
      outline:solid 5px var(--brand-dark-blue-900);
      outline-offset:5px;
      border-radius:50%;
      box-sizing:content-box;
      content:'';
      display:block;
      height:100%;
      position:absolute;
      width:100%;
      top:0;
      left:0;
      z-index:2;
    }

.outline-video.hero{
  height:100%;
  width:100%;
}

.outline-video.hero .outline-video--button{
    right:5%;
    bottom:10%;
    z-index:1;
  }

.outline-video.modal .outline-video--button, .outline-video.player .outline-video--button{
    right:50%;
    bottom:50%;
  }
`;